import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ReferAFriendLabels } from './refer-a-friend-labels.model';
import {
  getError,
  getLabels,
  getLabelsFetched,
} from './refer-a-friend-data.reducer';

@Injectable()
export class ReferAFriendDataStore {
  constructor(private _store: Store<any>) {}

  getLabels(): Observable<ReferAFriendLabels> {
    return this._store.select(getLabels);
  }

  getLabelsFetched(): Observable<boolean> {
    return this._store.select(getLabelsFetched);
  }

  getError(): Observable<any[]> {
    return this._store.select(getError);
  }
}
